import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";
import type { ComponentProps, ReactElement } from "react";
import { tui } from "../locale";

/** Says what the shared materials are on the item that leads into them: the catalog's own name does not. */
export const OpenToolsHint = ({
	children,
	side,
}: {
	children: ReactElement;
	side: ComponentProps<typeof TooltipContent>["side"];
}) => (
	<Tooltip>
		<TooltipTrigger asChild>{children}</TooltipTrigger>
		<TooltipContent side={side}>{tui("open.hint")}</TooltipContent>
	</Tooltip>
);
